









import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const retreatCouponModule = namespace("retreatCoupon");
@Component
export default class SearchType extends Vue {
  @retreatCouponModule.State("selectStep") active!: number;
  mounted() {
    this.setActive();
  }
  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 0);
  }
  handleSearchClick(bool: boolean) {
    if (bool) {
      this.$router.push({ path: `/retreatCoupon/couponSearch` });
    } else {
      this.$router.push({ path: `/retreatCoupon/mobileSearch` });
    }
  }
}
